import Link from 'next/link'

import React from 'react'

function BottomMenu({ menu }) {
    return (
        <>
            {(menu) ? (menu.menuItems.map((item) => (
                <Link key={item.id} href={item.value}><a className="text-gray-100 hover:underline hover:text-white">{item.name}</a></Link>
            ))) : ('')}
        </>
    );
}

export default BottomMenu;